import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { sendToApi } from 'api/client'

interface Data {
  location_country_code: string
}

const fetchGeolocation = async () => {
  const result = await sendToApi<Data>(`/users/location`)

  if (result.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }
  return result.data
}

export const useGeolocation = (options?: UseQueryOptions<Data>) => useQuery<Data>(['geolocation'], fetchGeolocation)
